import { render, staticRenderFns } from "./overview-top-links.vue?vue&type=template&id=f98e4720&scoped=true"
import script from "./overview-top-links.vue?vue&type=script&lang=js"
export * from "./overview-top-links.vue?vue&type=script&lang=js"
import style0 from "./overview-top-links.vue?vue&type=style&index=0&id=f98e4720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98e4720",
  null
  
)

export default component.exports